"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validatorJS = require("validator");
class IsNumericStringValidator {
    isValid(input) {
        if (input) {
            return validatorJS.isNumeric(input);
        }
        return false;
    }
}
exports.IsNumericStringValidator = IsNumericStringValidator;
//# sourceMappingURL=IsNumericStringValidator.js.map